<script setup lang="ts">
import { ref } from "vue";
import NavigationBar from "@/components/ui/NavigationBar.vue";
import TabBarMobile from "../ui/TabBarMobile.vue";
const currentAge = ref(new Date().getFullYear());
</script>

<template>
  <div class="layout-default">
    <NavigationBar />
    <div class="app-framework"><slot /></div>
    <TabBarMobile />
    <footer class="d-none d-md-block">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <!-- <p class="brand-footer"><img src="@/assets/images/logo_horiz.svg" alt=""></p> -->
            <p class="copy-footer">
              Copyright &copy; {{ currentAge }} -
              <img src="@/assets/images/logo_horiz.svg" alt="" />
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.app-framework {
  background-color: var(--dark-grey);
  min-height: calc(100vh - 170px);
  padding: 1.5rem 0;
}

.layout-default {
  min-height: 100vh;
}

.layout-default > header {
  display: table;
}

.layout-default > header > .breadcrumbs {
  margin: 30px 0 5px;
}

.layout-default > header > h1 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-top: 30px;
  margin-bottom: 20px;
}

.layout-default > header > .breadcrumbs + h1 {
  margin-top: 0;
}

.framework-slot > .toolbar {
  margin-bottom: 10px;
}

.framework-slot > .toolbar > .col {
  margin-bottom: 10px;
}

.layout-default > footer {
  margin-top: 0 auto;
  padding: 10px;
  background-color: var(--black-eigengrau);
}

.layout-default > footer .brand-footer {
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  font-size: 1.57rem;
  line-height: 1em;
  margin-bottom: 0;
  text-align: center;
  float: left;
  color: #999;
}

.layout-default > footer .brand-footer img {
  height: 25px;
}
.layout-default > footer .copy-footer {
  float: right;
  text-align: center;
  color: #999;
}
.layout-default > footer .copy-footer img {
  height: 22px;
  vertical-align: top;
  margin-right: 10px;
}
</style>
